<template>
	<el-container>
		<index-header></index-header>
		<el-container>
			<index-aside></index-aside>
			<index-main></index-main>
		</el-container>
	</el-container>
</template>
<script>
	import IndexHeader from '@/components/index/IndexHeader'
	import IndexAside from '@/components/index/IndexAsideStatic'
	import IndexMain from '@/components/index/IndexMain'
	export default {
		components: {
			IndexHeader,
			IndexAside,
			IndexMain
		}
	}
</script>

<style lang="scss" scoped>
	// 若依风格 - 铺满全屏
	.el-container {
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
		bottom: 0;
		background-color: #f0f2f5;
	}
	
	// 若依风格 - 主内容区域
	::v-deep .el-main {
		background-color: #f0f2f5;
		padding: 20px;
		transition: all 0.3s;
	}
	
	// 若依风格 - 侧边栏过渡动画
	::v-deep .el-aside {
		transition: width 0.3s;
	}
</style>
